export const countryCodeData = {
  'Faroe Islands': 'fo',
  'United States Minor Outlying Islands': 'um',
  'United States of America': 'us',
  Japan: 'jp',
  Seychelles: 'sc',
  India: 'in',
  France: 'fr',
  'Federated States of Micronesia': 'fm',
  China: 'cn',
  Portugal: 'pt',
  'Serranilla Bank': 'sw',
  'Scarborough Reef': 'sh',
  Brazil: 'br',
  Kiribati: 'ki',
  Philippines: 'ph',
  Mexico: 'mx',
  Spain: 'es',
  'Bajo Nuevo Bank (Petrel Is.)': 'bu',
  Maldives: 'mv',
  'Spratly Islands': 'sp',
  'United Kingdom': 'gb',
  Greece: 'gr',
  'American Samoa': 'as',
  Denmark: 'dk',
  Greenland: 'gl',
  Guam: 'gu',
  'Northern Mariana Islands': 'mp',
  'Puerto Rico': 'pr',
  'United States Virgin Islands': 'vi',
  Canada: 'ca',
  'Sao Tome and Principe': 'st',
  'Cape Verde': 'cv',
  Dominica: 'dm',
  Netherlands: 'nl',
  Jamaica: 'jm',
  Samoa: 'ws',
  Oman: 'om',
  'Saint Vincent and the Grenadines': 'vc',
  Turkey: 'tr',
  Bangladesh: 'bd',
  'Saint Lucia': 'lc',
  Nauru: 'nr',
  Norway: 'no',
  'Saint Kitts and Nevis': 'kn',
  Bahrain: 'bh',
  Tonga: 'to',
  Finland: 'fi',
  Indonesia: 'id',
  Mauritius: 'mu',
  Sweden: 'se',
  'Trinidad and Tobago': 'tt',
  Malaysia: 'my',
  Panama: 'pa',
  Palau: 'pw',
  Tuvalu: 'tv',
  'Marshall Islands': 'mh',
  Chile: 'cl',
  Thailand: 'th',
  Grenada: 'gd',
  Estonia: 'ee',
  'Antigua and Barbuda': 'ag',
  Taiwan: 'tw',
  Barbados: 'bb',
  Italy: 'it',
  Malta: 'mt',
  Vanuatu: 'vu',
  Singapore: 'sg',
  Cyprus: 'cy',
  'Sri Lanka': 'lk',
  Comoros: 'km',
  Fiji: 'fj',
  Russia: 'ru',
  Vatican: 'va',
  'San Marino': 'sm',
  Kazakhstan: 'kz',
  Azerbaijan: 'az',
  Tajikistan: 'tj',
  Lesotho: 'ls',
  Uzbekistan: 'uz',
  Morocco: 'ma',
  Colombia: 'co',
  'East Timor': 'tl',
  'United Republic of Tanzania': 'tz',
  Argentina: 'ar',
  'Saudi Arabia': 'sa',
  Pakistan: 'pk',
  Yemen: 'ye',
  'United Arab Emirates': 'ae',
  Kenya: 'ke',
  Peru: 'pe',
  'Dominican Republic': 'do',
  Haiti: 'ht',
  'Papua New Guinea': 'pg',
  Angola: 'ao',
  Cambodia: 'kh',
  Vietnam: 'vn',
  Mozambique: 'mz',
  'Costa Rica': 'cr',
  Benin: 'bj',
  Nigeria: 'ng',
  Iran: 'ir',
  'El Salvador': 'sv',
  'Sierra Leone': 'sl',
  'Guinea Bissau': 'gw',
  Croatia: 'hr',
  Belize: 'bz',
  'South Africa': 'za',
  'Central African Republic': 'cf',
  Sudan: 'sd',
  'Democratic Republic of the Congo': 'cd',
  Kuwait: 'kw',
  Germany: 'de',
  Belgium: 'be',
  Ireland: 'ie',
  'North Korea': 'kp',
  'South Korea': 'kr',
  Guyana: 'gy',
  Honduras: 'hn',
  Myanmar: 'mm',
  Gabon: 'ga',
  'Equatorial Guinea': 'gq',
  Nicaragua: 'ni',
  Latvia: 'lv',
  Uganda: 'ug',
  Malawi: 'mw',
  Armenia: 'am',
  Somaliland: 'sx',
  Turkmenistan: 'tm',
  Zambia: 'zm',
  'Northern Cyprus': 'nc',
  Mauritania: 'mr',
  Algeria: 'dz',
  Lithuania: 'lt',
  Ethiopia: 'et',
  Eritrea: 'er',
  Ghana: 'gh',
  Slovenia: 'si',
  Guatemala: 'gt',
  'Bosnia and Herzegovina': 'ba',
  Jordan: 'jo',
  Syria: 'sy',
  Monaco: 'mc',
  Albania: 'al',
  Uruguay: 'uy',
  'Cyprus No Mans Area': 'cnm',
  Mongolia: 'mn',
  Rwanda: 'rw',
  Somalia: 'so',
  Bolivia: 'bo',
  Cameroon: 'cm',
  'Republic of Congo': 'cg',
  'Western Sahara': 'eh',
  'Republic of Serbia': 'rs',
  Montenegro: 'me',
  Togo: 'tg',
  Laos: 'la',
  Afghanistan: 'af',
  Ukraine: 'ua',
  Slovakia: 'sk',
  'Siachen Glacier': 'jk',
  Bulgaria: 'bg',
  Qatar: 'qa',
  Liechtenstein: 'li',
  Austria: 'at',
  Swaziland: 'sz',
  Hungary: 'hu',
  Romania: 'ro',
  Niger: 'ne',
  Luxembourg: 'lu',
  Andorra: 'ad',
  'Ivory Coast': 'ci',
  Liberia: 'lr',
  Brunei: 'bn',
  Iraq: 'iq',
  Georgia: 'ge',
  Gambia: 'gm',
  Switzerland: 'ch',
  Chad: 'td',
  Kosovo: 'kv',
  Lebanon: 'lb',
  Djibouti: 'dj',
  Burundi: 'bi',
  Suriname: 'sr',
  Israel: 'il',
  Mali: 'ml',
  Senegal: 'sn',
  Guinea: 'gn',
  Zimbabwe: 'zw',
  Poland: 'pl',
  Macedonia: 'mk',
  Paraguay: 'py',
  Belarus: 'by',
  'Czech Republic': 'cz',
  'Burkina Faso': 'bf',
  Namibia: 'na',
  Libya: 'ly',
  Tunisia: 'tn',
  Bhutan: 'bt',
  Moldova: 'md',
  'South Sudan': 'ss',
  Botswana: 'bw',
  'The Bahamas': 'bs',
  'New Zealand': 'nz',
  Cuba: 'cu',
  Ecuador: 'ec',
  Australia: 'au',
  Venezuela: 've',
  'Solomon Islands': 'sb',
  Madagascar: 'mg',
  Iceland: 'is',
  Egypt: 'eg',
  Kyrgyzstan: 'kg',
  Nepal: 'np',
};



// WEBPACK FOOTER //
// ./src/features/shared-components/chart/countryCode.js